import React from 'react';
import FromKitchenToHomeImage from '../assets/from-our-kitchen-to-your-home_second.jpg';
import HomeCookedFood from '../assets/home-cooked-food.jpg';
import PerfectForStudents from '../assets/perfect-for-student-second.jpg';
import TraditionalMeal from '../assets/traditional-indian-meal.jpg';
import FreshAndHygienic from '../assets/fresh-and-hygiene-second.jpg';
import VegFoodBenefits from '../assets/veg-food-benefits.jpg';
import { Link } from 'react-router-dom';

const BlogsTiles = () => {
	const tiles = [
		{ href: "/from-our-kitchen-to-your-heart-just-like-home", imgSrc: FromKitchenToHomeImage, alt: "From Our Kitchen to Your Heart – Just Like Home" },
		{ href: "/home-cooked-food-benefits", imgSrc: HomeCookedFood, alt: "Top 5 Benefits of Eating Home-Cooked Food Daily" },
		{ href: "/traditional-indian-food-never-out-of-style", imgSrc: TraditionalMeal, alt: "🍽️ Traditional Indian Meals That Never Go Out of Style" },
		{ href: "/perfect-for-students", imgSrc: PerfectForStudents, alt: "🎓 Why Shivay Durga Foods is Perfect for Students" },
		{ href: "/benefits-of-pure-veg-food", imgSrc: VegFoodBenefits, alt: "Top Benefits of Eating Pure Vegetarian Food" },
		{ href: "/freshness-and-hygiene", imgSrc: FreshAndHygienic, alt: "🧼 How We Ensure Freshness & Hygiene in Every Meal" },
	];

	return (
		<div className="tiles-container">
			{tiles.map((tile, index) => (
				<Link to={tile.href} className="tile-link" key={index}>
					<img src={tile.imgSrc} alt={tile.alt} className="tile-image" />
				</Link>
			))}
		</div>
	);
};
export default BlogsTiles;
